<nz-layout>
  @if (submenu?.length!<=1) { <nz-header>
    </nz-header>
    }
    @if (submenu?.length!>1) {
    <nz-header class="section-header">
      {{'Laboratory'|translate}}
    </nz-header>
    }
    <nz-content>
      @for (cm of submenu; track cm) {
      @if (cm.path==componentPaths.laboratoryFiles) {
      <app-laboratory-file [id]="cm.path" />
      }
      @if (cm.path==componentPaths.laboratoryResults) {
      <app-laboratory-result-section [id]="cm.path" />
      }
      }
    </nz-content>
</nz-layout>